import { Box, Card, Icon, IconButton, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface IItem {
  id: number;
  description: string;
  disabled?: boolean;
  startAdornment?: ReactNode;
  endAdornment?: ReactNode;
}

interface IProps {
  list: IItem[];
  editOnClick?: boolean;
  editIcon?: string;
  onClickEdit?: (id: number) => void;
  onClickDelete?: (id: number) => void;
  bgColor?: string;
  bgColorOnHover?: string;
  hover?: boolean;
}

export const List: React.FC<IProps> = ({
  list,
  editOnClick = false,
  editIcon = 'edit',
  onClickEdit,
  onClickDelete,
  bgColor = 'none',
  hover = false,
  bgColorOnHover = bgColor
}) => {
  return (
    <Box
      display='flex'
      flexDirection='column'
      gap={0.5}
    >
      {list.map((item) =>
        <Card
          variant='elevation'
          key={item.id}
          data-testid={`list-item-${item.id}`}
          sx={{
            backgroundColor: bgColor
          }}
        >
          <Box
            onClick={() => editOnClick && onClickEdit && onClickEdit(item.id)}
            display='flex'
            justifyContent='space-between'
            alignItems='center'
            padding={2}
            gap={2}
            sx={{
              backgroundColor: bgColor,
              ':hover': { backgroundColor: hover ? bgColorOnHover : bgColor, cursor: hover ? 'pointer' : 'inherit' }
            }}
          >
            <Box
              display='flex'
              alignItems='center'
              gap={2}
              sx={{ flex: 1, minWidth: 0 }}
            >
              {item.startAdornment}

              <Typography
                noWrap
                sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
              >
                {item.description}
              </Typography>

              {item.endAdornment && (
                <Box sx={{ flexShrink: 0 }}>
                  {item.endAdornment}
                </Box>
              )}
            </Box>

            <Box sx={{ flexShrink: 0 }}>
              {onClickEdit &&
                <IconButton onClick={() => onClickEdit(item.id)} disabled={item.disabled} data-testid={`btn-edit-${item.id}`}>
                  <Icon>{editIcon}</Icon>
                </IconButton>
              }

              {onClickDelete &&
                <IconButton onClick={() => onClickDelete(item.id)} disabled={item.disabled} data-testid={`btn-delete-${item.id}`}>
                  <Icon>delete</Icon>
                </IconButton>
              }
            </Box>
          </Box>
        </Card>
      )}
    </Box>
  );
};